import { Button, Tooltip, Typography } from '@mui/material';
import { SAMPLE_EDITOR_URL } from 'constants/urls';
import { useEditButtonStyles } from 'components/SampleEditor/components/styles';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import React from 'react';

export const EditSampleButton = ({ sampleId }) => {
  const { classes } = useEditButtonStyles();

  const handleEditRedirect = () => {
    window.open(`${SAMPLE_EDITOR_URL}?search=${sampleId}`);
  };

  return sampleId ? (
    <Tooltip title="Edit Sample Metadata">
      <Button
        disableRipple
        className={classes.editButton}
        onClick={handleEditRedirect}
      >
        <Typography className={classes.editButtonText}>
          Edit Sample Metadata
        </Typography>
        <OpenInNewIcon className={classes.editButtonIcon} />
      </Button>
    </Tooltip>
  ) : null;
};
